import getFolders from './folders';

const getFolder = (rootState, folderId) =>
  getFolders(rootState).find((folder) => folder.id === folderId) || null;

export default getFolder;
